document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    nav.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
  }));


  document.querySelectorAll('[data-mobile-search-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const panel = document.querySelector('[data-mobile-search]');
    if (!panel) return;
    const willOpen = panel.hasAttribute('hidden');
    if (willOpen) {
      panel.removeAttribute('hidden');
      panel.querySelector('input')?.focus();
    } else {
      panel.setAttribute('hidden', '');
    }
  }));

  document.querySelectorAll('[data-slideshow]').forEach(slider => {
    const slides = [...slider.querySelectorAll('[data-slide]')];
    const dots = [...slider.querySelectorAll('[data-dot]')];
    if (!slides.length) return;

    let index = 0;
    let timer = null;
    const delay = parseInt(slider.dataset.delay || '6000', 10);

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    };
    const next = () => show(index + 1);
    const prev = () => show(index - 1);
    const stop = () => { if (timer) clearInterval(timer); };
    const start = () => {
      stop();
      if (slides.length > 1 && slider.dataset.autoplay === 'true') timer = setInterval(next, delay);
    };

    slider.querySelector('[data-prev]')?.addEventListener('click', () => { prev(); start(); });
    slider.querySelector('[data-next]')?.addEventListener('click', () => { next(); start(); });
    dots.forEach((d, n) => d.addEventListener('click', () => { show(n); start(); }));

    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let deltaY = 0;
    let touching = false;
    const touchTarget = slider.querySelector('.hero-slider__viewport') || slider;
    const touchThreshold = 50;

    const onTouchStart = (e) => {
      if (!e.touches || e.touches.length !== 1) return;
      touching = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      deltaX = 0;
      deltaY = 0;
      stop();
    };

    const onTouchMove = (e) => {
      if (!touching || !e.touches || e.touches.length !== 1) return;
      deltaX = e.touches[0].clientX - startX;
      deltaY = e.touches[0].clientY - startY;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        e.preventDefault();
      }
    };

    const onTouchEnd = () => {
      if (!touching) return;
      touching = false;
      if (Math.abs(deltaX) > touchThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) next();
        else prev();
      }
      start();
    };

    touchTarget.addEventListener('touchstart', onTouchStart, { passive: true });
    touchTarget.addEventListener('touchmove', onTouchMove, { passive: false });
    touchTarget.addEventListener('touchend', onTouchEnd, { passive: true });
    touchTarget.addEventListener('touchcancel', onTouchEnd, { passive: true });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    show(0);
    start();
  });

  document.querySelectorAll('[data-horizontal-slider]').forEach(slider => {
    const track = slider.querySelector('[data-horizontal-track]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.review-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * .85;
    };
    slider.querySelector('[data-horizontal-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    slider.querySelector('[data-horizontal-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawers = [...document.querySelectorAll('[data-drawer]')];
  const openButtons = [...document.querySelectorAll('[data-drawer-open]')];

  const closeDrawers = () => {
    drawers.forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    openButtons.forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('drawer-open');
  };

  const openDrawer = (id, button) => {
    closeDrawers();
    const drawer = document.querySelector(`[data-drawer="${id}"]`);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    button?.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('drawer-open');
    drawer.querySelector('a,button')?.focus({ preventScroll: true });
  };

  openButtons.forEach(button => button.addEventListener('click', () => openDrawer(button.dataset.drawerOpen, button)));
  document.querySelectorAll('[data-drawer-close]').forEach(button => button.addEventListener('click', closeDrawers));
  overlay?.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  document.querySelectorAll('[data-variant-select]').forEach(sel => sel.addEventListener('change', e => {
    const opt = e.target.selectedOptions[0];
    const price = document.querySelector('[data-product-price]');
    if (price && opt?.dataset.price) price.textContent = opt.dataset.price;
  }));
});
